import { BottomSheetIllustrationContent, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface NfcNotSupportedContentProps {
  workplaceName: string;
  onRetryNfc: () => void;
  onConvertToNonInstantPay: () => void;
  onCancel: () => void;
}

export function NfcNotSupportedContent(props: NfcNotSupportedContentProps) {
  const { workplaceName, onRetryNfc, onConvertToNonInstantPay, onCancel } = props;

  return (
    <>
      <BottomSheetIllustrationContent
        illustrationType="error"
        title="NFC not available"
        description={
          <Stack spacing={5} alignItems="center" textAlign="center">
            <Text>
              It looks like NFC scanning is not available on your device or is currently disabled.
            </Text>
            <Text>
              You must enable NFC in order to use Clipboard NFC time clocks at {workplaceName}.
            </Text>
            <Text>
              To enable NFC on your device, please go to device settings and search for
              &quot;NFC&quot;. You should see an option to turn on NFC.
            </Text>
            <Text>Alternatively, you can convert to non-InstantPay to clock in.</Text>
          </Stack>
        }
      />

      <DialogFooter orientation="vertical" onClose={onCancel}>
        <Stack spacing={2} width="100%" alignItems="center">
          <Button fullWidth variant="contained" size="large" onClick={onRetryNfc}>
            Try again
          </Button>

          <Button fullWidth variant="outlined" size="large" onClick={onConvertToNonInstantPay}>
            Convert to non-InstantPay
          </Button>
        </Stack>
      </DialogFooter>
    </>
  );
}
